import api from './api';

export interface IPasswordResetLinkResponse {
  user: {
    id: string;
    name: string;
    email: string;
  };
  password_reset_link: string;
}

/**
 * Gera link de recuperação de senha para um usuário (admin)
 */
export const generatePasswordResetLink = async (
  userId: string,
): Promise<IPasswordResetLinkResponse> => {
  const response = await api.get(`/auth/admin/${userId}/password-reset-link`);
  return response.data.data;
};

/**
 * Envia email de recuperação de senha para um usuário (admin)
 */
export const sendPasswordResetEmail = async (
  userId: string,
): Promise<{ user: { id: string; name: string; email: string } }> => {
  const response = await api.post(
    `/auth/admin/${userId}/send-password-reset-email`,
  );
  return response.data.data;
};
